export default "/public/dist/img/Certificazionefoto_3.jpg";